import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import './index.css';
import App from './App';
import 'react-datepicker/dist/react-datepicker.css';
import { Auth0Provider } from '@auth0/auth0-react';
import './styles.css';
import './i18n';
import LoadingCompass from './components/loading/LoadingCompass';

const onRedirectCallback = (appState) => {
  const targetUrl = appState?.returnTo || window.location.pathname;
  window.history.replaceState({}, document.title, targetUrl);
};

const providerConfig = {
  domain: import.meta.env.VITE_AUTH0_DOMAIN,
  clientId: import.meta.env.VITE_AUTH0_CLIENT_ID,
  onRedirectCallback,
  authorizationParams: {
    redirect_uri: window.location.origin,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: import.meta.env.VITE_AUTH0_SCOPE,
  },
  cacheLocation: 'localstorage',
};

const container = document.getElementById('root');

// This makes sure that it only creates a new root if it doesn't already exist.
// It is related to HMR, see this issue for more context https://github.com/vitejs/vite-plugin-react/issues/173
let root;
if (!container._reactRoot) {
  root = createRoot(container);
  container._reactRoot = root;
} else {
  root = container._reactRoot;
}
root.render(
  <StrictMode>
    <Auth0Provider {...providerConfig}>
      <React.Suspense
        fallback={
          <>
            <LoadingCompass loadingText={'Loading...'} />
          </>
        }
      >
        <App />
      </React.Suspense>
    </Auth0Provider>
  </StrictMode>,
);
